export default class LazyLoadingComponent {
    private numOfCpcAdsWithoutLazyLoading: number = 2;

    public setupLazyLoading = () => {
        this.showFirstLazyImages();
        this.checkLazyLoad();
        document.addEventListener('scroll', () => this.checkLazyLoad());
    };

    private showFirstLazyImages = () => {
        const firstImages: Array<HTMLElement> = Array.from(document.querySelectorAll('.listing-card img[data-lazy="true"]'))
            .slice(0, this.numOfCpcAdsWithoutLazyLoading) as HTMLElement[];
        firstImages.forEach(image => {
            image.style.transition = 'none';
            image.setAttribute("loading", "eager");
            this.renderGivenImage(image);
        });
    };

    public checkLazyLoad = () => {
        const notLoadedImages: Array<HTMLElement> = Array.from(document.querySelectorAll('.listing-card img[data-lazy="true"]:not(.loaded)'));
        if (notLoadedImages.length > 0) {
            notLoadedImages.forEach(image => {
                if (this.isGivenElementVisibleInViewport(image)) {
                    this.renderGivenImage(image);
                }
            });
        }
    };
    private isGivenElementVisibleInViewport = (element: HTMLElement) => {
        return this.getWindowScrolledPixels() > this.getDistanceFromElementToTop(element);
    };
    private renderGivenImage = (image: HTMLElement) => {
        image.classList.add("loaded");
        const dataLazyImg = image.getAttribute("data-lazy-img")
        if (dataLazyImg) {
            image.setAttribute("src",  dataLazyImg);
        }
    }

    private getDistanceFromElementToTop = (element: HTMLElement) => {
        return window.scrollY + element.getBoundingClientRect().top;
    };

    private getWindowScrolledPixels = () => {
        return window.innerHeight + window.scrollY;
    };
}